const WIDTH_SIZES = {
  X_LARGE: 1366,
  LARGE: 1024,
  MEDIUM: 768,
  SMALL: 375
};

const HEIGHT_SIZES = {
  X_LARGE: 1366,
  LARGE: 1024,
  MEDIUM: 768,
  SMALL: 375
};

export default {
  WIDTH_SIZES,
  HEIGHT_SIZES,

  TABLET_MIN_WIDTH: 520,
  TABLET_MIN_HEIGHT: 520
};
